import React, {Component} from 'react'
import {connect} from 'react-redux';
import {Button, Table, Popconfirm, Icon} from 'antd';
import {API_ROOT, API_CODE_SUCCESS, API_CODE_RECORD_EXISTS} from '../../config';
import iconFolder from '../../assets/common/img/folder.svg';
import iconPdf from '../../assets/common/img/pdf.svg';

function bytesToSize(bytes) {
  bytes = parseInt(bytes, 10);
  if (bytes === 0)
    return '0 B';
  var k = 1024,
    sizes = [
      'B', 'KB', 'MB'
    ],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return (bytes / Math.pow(k, i)).toFixed(1) + ' ' + sizes[i];
}

class TableData extends Component {
  constructor(props) {
    super(props)

  }

  getRowKey = (handbook) => {
    return handbook['id'];
  }

  render() {
    const {
      handbookList,
      gotoDir,
      gotoParent,
      currentPid,
      showEditFormModal,
      handleDelDir,
      handleDelFile,
      authority
    } = this.props;

    /*浏览页面 和 操作页面的表格列宽度*/
    const colViewWidth = {
      name: '55%',
      size: '20%',
      uTime: '25%'
    }
    const colActionWidth = {
      name: '50%',
      size: '10%',
      uTime: '20%',
      action: '20%'
    }

    const renderDirName = (text, record) => {
      const returnHTML = <Button
        type="primary"
        onClick={() => {
        gotoParent(currentPid);
      }}><Icon type="left"/>返回
      </Button>
      const dirHTML = <a
        href="javascript:;"
        onClick={() => {
        gotoDir(record.id);
      }}
        style={{
        fontSize: 14
      }}>
        <img
          src={iconFolder}
          style={{
          marginRight: 5,
          display: 'inline-block',
          verticalAlign: 'bottom'
        }}/> {record.name}</a>
      if (record.type === 'r') {
        return returnHTML;
      } else {
        return dirHTML;
      }
    }

    const renderDirAction = (text, record) => {
      const delDirHTML = <span>
        <Button
          type="primary"
          style={{
          marginRight: 10
        }}
          onClick={() => {
          showEditFormModal(record)
        }}>修改</Button>
        <Popconfirm
          placement="top"
          title="是否删除该文件夹？“删除”的同时会删除该文件夹下的所有内容。"
          okText="删除"
          cancelText="取消"
          onConfirm={() => {
          handleDelDir(record.id)
        }}>
          <Button type="default">删除</Button>
        </Popconfirm>
      </span>
      if (record.type === 'r') {
        return;
      }
      return delDirHTML
    }

    const renderFileName = (text, record) => <a
      href={API_ROOT + record.path}
      target="_blank"
      style={{
      fontSize: 14
    }}><img
      src={iconPdf}
      style={{
      marginRight: 5,
      display: 'inline-block',
      verticalAlign: 'bottom'
    }}/> {record.name}</a>

    const renderFileAction = (text, record) => <span>
      <Popconfirm
        placement="top"
        title="是否删除该文件？"
        okText="删除"
        cancelText="取消"
        onConfirm={() => {
        handleDelFile(record.id)
      }}>
        <Button type="default">删除</Button>
      </Popconfirm>
    </span>

    /*浏览页面 和 操作页面的列选项*/
    const dirViewColumns = [
      {
        title: '名称',
        key: 'name',
        width: colViewWidth.name,
        render: renderDirName
      }, {
        title: '大小',
        key: 'size',
        width: colViewWidth.size
      }, {
        title: '最后修改时间',
        dataIndex: 'uTime',
        key: 'uTime',
        width: colViewWidth.uTime
      }
    ]

    const dirActionColumns = [
      {
        title: '名称',
        key: 'name',
        width: colActionWidth.name,
        render: renderDirName
      }, {
        title: '大小',
        key: 'size',
        width: colActionWidth.size
      }, {
        title: '最后修改时间',
        dataIndex: 'uTime',
        key: 'uTime',
        width: colActionWidth.uTime
      }, {
        title: '操作',
        key: 'action',
        width: colActionWidth.action,
        render: renderDirAction
      }
    ]

    const fileViewColumns = [
      {
        key: 'name',
        width: colViewWidth.name,
        render: renderFileName
      }, {
        key: 'size',
        width: colViewWidth.size,
        render: (text, record) => bytesToSize(record.size)
      }, {
        dataIndex: 'uTime',
        key: 'uTime',
        width: colViewWidth.uTime
      }
    ]
    const fileActionColumns = [
      {
        // dataIndex: 'name',
        key: 'name',
        width: colActionWidth.name,
        render: renderFileName
      }, {
        // dataIndex: 'size',
        key: 'size',
        width: colActionWidth.size,
        render: (text, record) => bytesToSize(record.size)
      }, {
        dataIndex: 'uTime',
        key: 'uTime',
        width: colActionWidth.uTime
      }, {
        key: 'action',
        width: colActionWidth.action,
        render: renderFileAction
      }
    ]

    let dirColumns = authority === 'v'
      ? dirViewColumns
      : dirActionColumns;
    let fileColumns = authority === 'v'
      ? fileViewColumns
      : fileActionColumns;

    return (
      <div>
        <Table
          columns={dirColumns}
          dataSource={handbookList.dir}
          rowKey={this.getRowKey}
          pagination={false}/>
        <Table
          columns={fileColumns}
          dataSource={handbookList.file}
          rowKey={this.getRowKey}
          pagination={false}
          showHeader={false}/>
      </div>
    )
  }
}

export default TableData;



// WEBPACK FOOTER //
// ./src/components/handbook/tableData.js